import { utils as ethersUtils } from 'ethers'
import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useNFCSInfo } from 'modules/nfcs/hooks/useNFCSInfo'

import { Title } from 'shared/ui/common/Title'
import { ProgressBar } from 'shared/ui/common/ProgressBar'
import { NFCSMintFinish } from 'modules/nfcs/ui/NFCSMintFinish'

import { createRoute } from 'modules/router/utils/createRoute'
import { getLibrary } from 'modules/blockChain/utils/getLibrary'
import { Chains } from 'modules/blockChain/chains'

const UNSUPPORTED_ERR_CODE = 'UNSUPPORTED_OPERATION'

function RouteProfile() {
  const { addressOrName } = useParams()
  const { walletAddress } = useWeb3()
  const [address, setAddress] = useState<string | null | undefined>()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const { nfcs, tokenId, isLoading } = useNFCSInfo({ address })

  const getAddress = useCallback(async () => {
    if (!addressOrName) return null
    const loweredAddressOrName = addressOrName.toLowerCase()

    if (ethersUtils.isAddress(loweredAddressOrName)) {
      return loweredAddressOrName
    }

    if (!ethersUtils.isValidName(loweredAddressOrName)) {
      return null
    }

    const library = getLibrary(Chains.Mainnet)
    const addressByName = await library
      .resolveName(loweredAddressOrName)
      .catch(error => {
        if (error?.code === UNSUPPORTED_ERR_CODE) {
          setErrorMessage('Network does not support ENS')
        }
        return null
      })

    return addressByName?.toLowerCase()
  }, [addressOrName])

  useEffect(() => {
    getAddress().then(setAddress)
  }, [getAddress])

  if (address === undefined) {
    return <ProgressBar isCentered />
  }

  if (errorMessage) {
    return <Title isCentered>{errorMessage}</Title>
  }

  if (address === null) {
    return <Title isCentered>Invalid address</Title>
  }

  return (
    <NFCSMintFinish
      nfcs={nfcs}
      tokenId={tokenId}
      walletAddress={address}
      isSelf={walletAddress?.toLowerCase() === address.toLowerCase()}
      isLoading={isLoading}
    />
  )
}

export const routeProfile = createRoute({
  headerTitle: 'Profile',
  layoutType: 'default',
  component: RouteProfile,
})
